import {Form} from 'antd';
import {FormInstance} from 'antd/es/form';
import React from 'react';

import {
    dynamicFieldResolver,
} from 'components/ais/monitor-services-card/monitor-service-dynamic-fields/lib/utils';
import {fieldDefaultWidthResolver} from 'components/form/field-type-resolver';
import {fieldValidationResolver, EMaskValidation} from 'components/form/utils/field-validation-resolver';
import {OPENTEXT_LOOKUP_CODE} from 'components/table/action/open-launch-program-modal';
import {EAdministrationOpenTextFieldsService} from 'components/table/action/open-launch-program-modal/open-launch-program-modal.constants';
import {EFieldType, IValidationRules} from 'entities/metadata';
import {IProgramArg} from 'store/api/monitor-services/monitor-services.types';
import {useAppSelector} from 'store/config/hooks';
import {selectDocumentsSigningMethod} from 'store/slices/documents-uploading-slice';

interface IAdministrationMonitorServiceDynamicFieldsProps {
    form: FormInstance;
    fields: IProgramArg[] | undefined;
    entityName: string;
    programName: string;
}

export const AdministrationMonitorServiceDynamicFields = ({
    form,
    fields,
    entityName,
    programName,
}: IAdministrationMonitorServiceDynamicFieldsProps) => {
    const documentsSigningMethod = useAppSelector(selectDocumentsSigningMethod);

    if (!fields?.length) return null;

    const getValidationRulesForMonitorServiceField = (field: IProgramArg): IValidationRules[] | undefined => {
        if (programName === OPENTEXT_LOOKUP_CODE) {
            switch (field?.code) {
            case EAdministrationOpenTextFieldsService.P_DATE_FROM:
                return [{mask: EMaskValidation.monitorServiceOpenTextDateFrom}];
            case EAdministrationOpenTextFieldsService.P_DATE_TO:
                return [{mask: EMaskValidation.monitorServiceOpenTextDateTo}];
            case EAdministrationOpenTextFieldsService.P_DOC_IDS:
                return [{mask: EMaskValidation.monitorServiceOpenTextDocIds}];
            default:
                return [];
            }
        }
        return undefined;
    };

    const getDefaultValue = (field: IProgramArg): string | undefined => {
        if (field?.valueType.lookupCode === EFieldType.TEXT
        || field?.valueType.lookupCode === EFieldType.STRING) {
            return field?.defaultValue ?? undefined;
        }

        return undefined;
    };

    return (
        <>
            {fields?.map(f => (
                f?.displayFlag
                    ? (
                        <Form.Item
                            key={f?.id || f?.code}
                            name={f?.code}
                            label={f?.name}
                            style={{
                                width: fieldDefaultWidthResolver(f?.valueType.lookupCode) ?? '100%',
                                display: !f?.displayFlag ? 'none' : 'block',
                            }}
                            rules={fieldValidationResolver({
                                validationRules: getValidationRulesForMonitorServiceField(f),
                                fieldMeta: {
                                    type: f?.valueType.lookupCode ?? EFieldType.STRING,
                                    label: f?.name ?? '',
                                    isRequired: f?.requiredFlag,
                                    isDisabled: !f.enabledFlag,
                                },
                            })}
                            initialValue={getDefaultValue(f)}
                        >
                            {dynamicFieldResolver({
                                form,
                                documentsSigningMethod,
                                entityName,
                                type: f?.valueType.lookupCode,
                                isDisabled: !f.enabledFlag,
                                defaultValue: getDefaultValue(f),
                                referenceUrl: `lookupValue/${f.valuesetLookupType?.lookupType}`,
                                fieldKey: f.code,
                                useFirstOptionAsDefaultValue: false,
                            })}
                        </Form.Item>
                    ) : null
            ))}
        </>
    );
};
